import React, { useEffect, useRef, useState } from "react"
import "./AllInstitution.scss"
import { useNavigate } from "react-router-dom"
import InstituteApi from "Api/InstituteApi"
import {
  Button,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Spinner,
  Table,
  Input,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import { toast } from "react-toastify"
import { ToastContainer } from "react-toastify"

const InstitutionListTable = () => {
  document.title = "Institution"
  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const [instituteDetails, setInstituteDetails] = useState([])
  const userData = JSON.parse(localStorage.getItem("userData"))
  const [filteredInstitutionDetails, setFilteredInstitutionDetails] = useState(
    [],
  )

  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)
  const [filterStatus, setFilterStatus] = useState("all")

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Institution", link: "#" },
    { label: "Institution List", link: "#" },
  ]

  const [loading, setLoading] = useState(true)
  const [addInstitutionLoader, setAddInstitutionLoader] = useState(false)

  const getAllInstitutionDetails = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit: limit,
        page: page,
      },
    }

    InstituteApi.getAllInstitutions(config)
      .then(response => {
        setLoading(false)
        setInstituteDetails(response.data.institution)
        setTotalRecords(response.data.totalRecords)
      })
      .catch(error => {
      })
  }

  useEffect(() => {
    getAllInstitutionDetails()
  }, [accessToken, page, limit])

  useEffect(() => {
    if (filterStatus === "all") {
      setFilteredInstitutionDetails(instituteDetails)
    } else {
      const filteredData = instituteDetails.filter(
        institution => institution.verifiedStatus === filterStatus,
      )
      setFilteredInstitutionDetails(filteredData)
    }
  }, [filterStatus, instituteDetails])

  const totalPages = Math.ceil(totalRecords / limit)

  const uploadbtn = useRef()

  const handleUploadButtonClick = () => {
    uploadbtn.current.click()
  }

  const [excelLoader, setExcelLoader] = useState(false)

  const handleFileChange = event => {
    setExcelLoader(true)
    const file = event.target.files[0]
    if (!file) return
    const formData = new FormData()
    formData.append("file", file)

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    InstituteApi.uploadInstitutionByExcel(formData, config)
      .then(res => {
        getAllInstitutionDetails()
        event.target.value = ""
        setExcelLoader(false)
        toast.success(res.data.message)
      })
      .catch(err => {
        event.target.value = ""
        setExcelLoader(false)
        toast.error(err.response.data.message)
      })
  }
  const handleAddInstitutionClick = () => {
    setAddInstitutionLoader(true)
    setTimeout(() => {
      setAddInstitutionLoader(false)
      navigate("/addInstituion")
    }, 500)
  }

  const [selectedInstitutions, setSelectedInstitutions] = useState([])
  const toggleSelectAll = () => {
    if (selectedInstitutions.length === filteredInstitutionDetails.length) {
      setSelectedInstitutions([])
    } else {
      setSelectedInstitutions(filteredInstitutionDetails.map(inst => inst._id))
    }
  }

  const toggleSelection = instId => {
    setSelectedInstitutions(prevInst =>
      prevInst.includes(instId)
        ? prevInst.filter(id => id !== instId)
        : [...prevInst, instId],
    )
  }

  const handleUpdateStatus = newStatus => {
    if (selectedInstitutions.length === 0) {
      toast.warn("Please select at least one Institution to update.")
      return
    }

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    const payload = {
      institutionIds: selectedInstitutions,
      newStatus: newStatus,
    }

    InstituteApi.updateInstitutionStatus(payload, config)
      .then(response => {
        if (response.data.status) {
          toast.success(response.data.message)
          getAllInstitutionDetails()
          setSelectedInstitutions([])
        }
      })
      .catch(error => {
        toast.error("Failed to update Institution status.")
      })
  }

  return (
    <div className="institution-data-table">
      <ToastContainer />
      <Row>
        <Col xs="12">
          <div className="institution-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Institution" />

            <div className="d-flex align-items-center gap-3">
              {selectedInstitutions.length === 0 && (
                <>
                  <Input
                    type="select"
                    value={filterStatus}
                    onChange={e => setFilterStatus(e.target.value)}
                    style={{ width: "150px" }}
                  >
                    <option value="all">All</option>
                    <option value="approve">Approved</option>
                    <option value="reject">Rejected</option>
                    <option value="pending">Pending</option>
                  </Input>

                  <input
                    type="file"
                    ref={uploadbtn}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  <Button
                    type="button"
                    color="success"
                    className="waves-effect"
                    onClick={handleUploadButtonClick}
                  >
                    {excelLoader ? (
                      <Spinner size="sm" />
                    ) : (
                      <i className="mdi mdi-microsoft-excel" />
                    )}
                  </Button>

                  <Button
                    type="button"
                    color="secondary"
                    className="waves-effect"
                    onClick={handleAddInstitutionClick}
                  >
                    {/* {addInstitutionLoader ? (
                  <Spinner size="sm" />
                ) : (
                  "Add Institution"
                )} */}
                    Add Institution
                  </Button>
                </>
              )}

              {selectedInstitutions.length > 0 && (
                <>
                  <Button
                    type="button"
                    color="primary"
                    className="waves-effect"
                    onClick={() => handleUpdateStatus("approve")}
                  >
                    Approve
                  </Button>
                  <Button
                    type="button"
                    color="danger"
                    className="waves-effect"
                    onClick={() => handleUpdateStatus("reject")}
                  >
                    Reject
                  </Button>
                </>
              )}
            </div>
          </div>

          <div className="institution-data-table table-responsive mt-4 mb-3 ">
            {loading ? (
              <DataTableLoader cols={10} />
            ) : (
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        onClick={toggleSelectAll}
                        checked={
                          selectedInstitutions.length ===
                          filteredInstitutionDetails.length
                        }
                      />
                    </th>
                    <th>#</th>
                    <th>Institution Name</th>
                    <th>Type</th>
                    <th> Year Established</th>
                    <th >
                      <span className="d-flex align-items-center gap-2 justify-content-center">
                        Category{" "}
                        <span
                          // onClick={handleFilterIconClick}
                          style={{ cursor: "pointer", marginLeft: "10px" }}
                        >
                          <i className="fas fa-filter"></i>
                        </span>
                      </span>
                    </th>
                    <th>UGC Approval</th>
                    <th>Verified Status</th>
                    <th>Edit</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredInstitutionDetails.map((institution, index) => (
                    <tr key={institution._id} className="university-table-row">
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedInstitutions.includes(
                            institution._id,
                          )}
                          onClick={() => toggleSelection(institution._id)}
                        />
                      </td>
                      <th scope="row">{(page - 1) * limit + index + 1}</th>
                      <td>{institution.institutionName}</td>
                      <td>{institution.type}</td>
                      <td>{institution.yearEstablished}</td>
                      <td>{institution.category}</td>

                      <td>{institution.ugcApproval ? "Yes" : "No"} </td>
                      <td>
                        <span
                          className={`status ${institution.verifiedStatus.toLowerCase()}`}
                        >
                          {institution.verifiedStatus === "approve"
                            ? "Approved"
                            : institution.verifiedStatus === "reject"
                              ? "Rejected"
                              : "Pending"}
                        </span>
                      </td>

                      {institution?.verifiedStatus === "pending" ||
                      (["approve", "reject"].includes(
                        institution?.verifiedStatus,
                      ) &&
                        userData?.role === "manager") ? (
                        <td>
                          <span
                            className="edit-institution"
                            onClick={() => {
                              navigate(
                                `/edit-institution/${institution?.institutionCode}`,
                                { state: institution },
                              )
                            }}
                          >
                            <i className="ion ion-md-create" />
                          </span>
                        </td>
                      ) : (
                        <td>
                          <span className="edit-institution">
                            <i className="fas fa-ban" />
                          </span>
                        </td>
                      )}

                      <td>
                        <span
                          onClick={() => {
                            navigate(
                              `/view-institution/${institution?.institutionCode}`,
                              { state: institution },
                            )
                          }}
                          className="view-institution"
                        >
                          <i className="ion ion-md-eye" />
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
          <div className="pagination-container d-flex align-items-center justify-content-end">
            <Pagination>
              <PaginationItem disabled={page <= 1}>
                <PaginationLink previous onClick={() => setPage(page - 1)} />
              </PaginationItem>
              {[...Array(Math.min(3, totalPages))].map((_, index) => (
                <PaginationItem key={index} active={index + 1 === page}>
                  <PaginationLink onClick={() => setPage(index + 1)}>
                    {index + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}

              {totalPages > 6 && page > 3 && page < totalPages - 2 && (
                <PaginationItem disabled>
                  <PaginationLink>...</PaginationLink>
                </PaginationItem>
              )}

              {totalPages > 6 && page > 3 && page < totalPages - 2 && (
                <PaginationItem active>
                  <PaginationLink onClick={() => setPage(page)}>
                    {page}
                  </PaginationLink>
                </PaginationItem>
              )}

              {totalPages > 6 && page < totalPages - 2 && (
                <PaginationItem disabled>
                  <PaginationLink>...</PaginationLink>
                </PaginationItem>
              )}

              {totalPages > 3 &&
                [...Array(Math.min(3, totalPages))].map((_, index) => {
                  const pageNumber = totalPages - 2 + index
                  return (
                    <PaginationItem
                      key={pageNumber}
                      active={pageNumber === page}
                    >
                      <PaginationLink onClick={() => setPage(pageNumber)}>
                        {pageNumber}
                      </PaginationLink>
                    </PaginationItem>
                  )
                })}
              <PaginationItem disabled={page >= totalPages}>
                <PaginationLink next onClick={() => setPage(page + 1)} />
              </PaginationItem>
            </Pagination>
          </div>
        </Col>
      </Row>
    </div>
  )
}

  export default InstitutionListTable
